import React from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import Header from "../components/layouts/Header";
import SideBar from "../components/layouts/Sidebar";
import pusher from "../pusherConfig";
import { toast } from "react-toastify";
import { Howl } from "howler";
import "./Table.scss";
import Timer from "../components/form-controls/Timer";
import { configCheck } from "./commonAction";
import BookingToaster from "./BookingToaster";
import NotificationBar from "../components/layouts/NotificationBar";
import authorization from "../utility/authorization";

// import BreadCrumb from "../components/layouts/BreadCrumb";

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toastData: null,
      toastEventType: null,
    };
  }

  componentDidMount() {
    const storedData = localStorage.getItem("bookingData");
    const storedCancelData = localStorage.getItem("bookingCancelData");
    const storedUpdateData = localStorage.getItem("bookingUpdateData");
    const storedEnquiryData = localStorage.getItem("bookingEnquiryData");
    const storedSLABreachedData = localStorage.getItem("slaBreachedData");
    const storedCustomerData = localStorage.getItem("bookingCustomerData");
    const storedCustomerCancelData = localStorage.getItem(
      "bookingCustomerCancelData",
    );
    const storedDriverRegData = localStorage.getItem("driverRegData");
    if (storedData) {
      // Delay the execution of eventHandler by 3 seconds
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedData), "booking-create");
        // Clear the stored data after handling
        localStorage.removeItem("bookingData");
      }, 3000);
    }

    if (storedCancelData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedCancelData), "booking-cancel");
        localStorage.removeItem("bookingCancelData");
      }, 3000);
    }
    if (storedUpdateData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedUpdateData), "booking-update");
        localStorage.removeItem("bookingUpdateData");
      }, 3000);
    }
    if (storedEnquiryData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedEnquiryData), "fare-requested");

        localStorage.removeItem("bookingEnquiryData");
      }, 3000);
    }
    // if (storedEnquiryData) {
    //   setTimeout(() => {
    //     this.eventHandler(JSON.parse(storedEnquiryData), "enquiries");
    //     localStorage.removeItem("bookingEnquiryData");
    //   }, 3000);
    // }
    if (storedSLABreachedData) {
      setTimeout(() => {
        this.eventHandler(JSON.parse(storedSLABreachedData), "sla-breached");
        localStorage.removeItem("slaBreachedData");
      }, 3000);
    }
    if (storedCustomerData) {
      setTimeout(() => {
        this.eventHandler(
          JSON.parse(storedCustomerData),
          "booking-create-customer",
        );
        localStorage.removeItem("bookingCustomerData");
      }, 3000);
    }
    if (storedCustomerCancelData) {
      setTimeout(() => {
        this.eventHandler(
          JSON.parse(storedCustomerCancelData),
          "booking-cancel-customer",
        );
        localStorage.removeItem("bookingCustomerCancelData");
      }, 3000);
    }
    if (storedDriverRegData) {
      setTimeout(() => {
        this.eventHandler(
          JSON.parse(storedDriverRegData),
          "new-driver-registered",
        );
        localStorage.removeItem("driverRegData");
      }, 3000);
    }

    this.props.isLoggedIn() && this.props.dispatch(configCheck());

    this.channel1 = pusher.subscribe("taxida-bookings");
    this.channel2 = pusher.subscribe("user-service");
    this.channel3 = pusher.subscribe("taxida-enquiries");
    this.channel1.bind("booking-create", this.handleBookingCreate, this);
    this.channel1.bind("booking-cancel", this.handleBookingCancel, this);
    this.channel1.bind("booking-update", this.handleBookingUpdate, this);
    // this.channel1.bind("enquiries", this.handleBookingEnquiry, this);
    this.channel1.bind("sla-breached", this.handleSLABreached);
    this.channel1.bind(
      "booking-create-customer",
      this.handleCustomerCreate,
      this,
    );
    this.channel1.bind(
      "booking-cancel-customer",
      this.handleCustomerCancel,
      this,
    );
    this.channel2.bind("user-service", this.handleDriverReg, this);

    this.channel1.bind_global((eventName, eventData) => {
      console.log(
        `Event "${eventName}" triggered on taxida-bookings channel:`,
        eventData,
      );

      if (eventName === "sla-breached") {
        console.log("Dispatching sla-breached event to window...");
        window.dispatchEvent(
          new CustomEvent("eventName", { detail: eventData }),
        );
      }
    });

    this.channel2.bind_global((eventName, eventData) => {
      console.log(
        `Event "${eventName}" triggered on user-service channel:`,
        eventData,
      );
      this.eventHandler(eventData, eventName);
    });

    // enquiry
    this.channel3.bind("pusher:subscription_succeeded", () => {
      console.log("Subscribed to taxida-enquiries");
    });
    // Uncomment to re-enable enquiry (fare-requested) notification
    // this.channel3.bind("fare-requested", this.handleFareRequested);

    this.channel3.bind_global((eventName, data) => {
      console.log("taxida-enquiries global event:", eventName, data);
    });

    this.channel3.bind("pusher:subscription_error", (status) => {
      console.error("taxida-enquiries subscription error:", status);
    });
    // booking confirmed for agent
    this.channel1.bind(
      "booking-confirmed-agent",
      this.handleBookingConfirmedAgent,
      this,
    );

    // booking confirmed for customer
    this.channel1.bind(
      "booking-confirmed-customer",
      this.handleBookingConfirmedCustomer,
      this,
    );
  }

  // componentWillUnmount() {
  //   if (this.channel) {
  //     this.channel.unbind("booking-create", this.eventHandler);
  //     this.channel.unbind("booking-cancel", this.eventHandler);
  //     this.channel.unbind("booking-update", this.eventHandler);
  //     this.channel.unbind("enquiries", this.eventHandler);
  //     this.channel.unbind("booking-create-customer", this.eventHandler);
  //     this.channel.unbind("booking-cancel-customer", this.eventHandler);
  //     this.channel.unbind("new-driver-registered", this.eventHandler);
  //     pusher.unsubscribe("taxida-bookings");
  //     pusher.unsubscribe("user-service");
  //   }
  // }
  componentWillUnmount() {
    // Unbind event handlers and unsubscribe from channel 1
    if (this.channel1) {
      this.channel1.unbind("booking-create", this.handleBookingCreate);
      this.channel1.unbind("booking-cancel", this.handleBookingCancel);
      this.channel1.unbind("booking-update", this.handleBookingUpdate);
      this.channel1.unbind("enquiries", this.handleBookingEnquiry);
      this.channel1.unbind("sla-breached", this.handleSLABreached);
      this.channel1.unbind(
        "booking-confirmed-agent",
        this.handleBookingConfirmedAgent,
      );

      this.channel1.unbind(
        "booking-confirmed-customer",
        this.handleBookingConfirmedCustomer,
      );
      this.channel1.unbind(
        "booking-create-customer",
        this.handleCustomerCreate,
      );
      this.channel1.unbind(
        "booking-cancel-customer",
        this.handleCustomerCancel,
      );
      // Unbind more event handlers as needed
      pusher.unsubscribe("taxida-bookings");
    }

    // Unbind event handlers and unsubscribe from channel 2
    if (this.channel2) {
      this.channel2.unbind("new-driver-registered", this.handleDriverReg);
      pusher.unsubscribe("user-service");
    }
    if (this.channel3) {
      this.channel3.unbind("fare-requested", this.handleFareRequested);

      pusher.unsubscribe("taxida-enquiries");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isLoggedIn() &&
      prevProps.configCheck.response !== this.props.configCheck.response
    ) {
      const { status } = this.props.configCheck.response;
      if (status === false) {
        this.handleLogout();
      }
    }
    // Reset toastData and toastEventType state after rendering BookingToaster
    if (prevState.toastData !== null && prevState.toastEventType !== null) {
      this.setState({
        toastData: null,
        toastEventType: null,
      });
    }
  }
  handleLogout = () => {
    authorization.logout();
    // this.props.history.push("/login");
  };

  handleBookingCreate = (data) => {
    localStorage.setItem("bookingData", JSON.stringify(data));
    if (window.location.pathname === "/b2btrips") {
      // window.location.reload();
      this.eventHandler(data, "booking-create");
      localStorage.removeItem("bookingData");
    } else {
      this.eventHandler(data, "booking-create");
      localStorage.removeItem("bookingData");
    }
  };

  handleBookingCancel = (data) => {
    localStorage.setItem("bookingCancelData", JSON.stringify(data));
    if (window.location.pathname === "/b2btrips") {
      // window.location.reload();
      this.eventHandler(data, "booking-cancel");
      localStorage.removeItem("bookingCancelData");
    } else {
      this.eventHandler(data, "booking-cancel");
      localStorage.removeItem("bookingCancelData");
    }
  };
  handleBookingUpdate = (data) => {
    localStorage.setItem("bookingUpdateData", JSON.stringify(data));
    if (window.location.pathname === "/b2btrips") {
      // window.location.reload();
      this.eventHandler(data, "booking-update");
      localStorage.removeItem("bookingUpdateData");
    } else {
      this.eventHandler(data, "booking-update");
      localStorage.removeItem("bookingUpdateData");
    }
  };

  handleBookingEnquiry = (data) => {
    localStorage.setItem("bookingEnquiryData", JSON.stringify(data));
    if (window.location.pathname === "/trips") {
      // window.location.reload();
      this.eventHandler(data, "enquiries");
      localStorage.removeItem("bookingEnquiryData");
    } else {
      this.eventHandler(data, "enquiries");
      localStorage.removeItem("bookingEnquiryData");
    }
  };
  handleSLABreached = (data) => {
    localStorage.setItem("slaBreachedData", JSON.stringify(data));
    if (window.location.pathname === "/trips") {
      this.eventHandler(data, "sla-breached");
      localStorage.removeItem("slaBreachedData");
    } else {
      this.eventHandler(data, "sla-breached");
      localStorage.removeItem("slaBreachedData");
    }
  };

  handleCustomerCreate = (data) => {
    localStorage.setItem("bookingCustomerData", JSON.stringify(data));
    if (window.location.pathname === "/trips") {
      // window.location.reload();
      this.eventHandler(data, "booking-create-customer");
      localStorage.removeItem("bookingCustomerData");
    } else {
      this.eventHandler(data, "booking-create-customer");
      localStorage.removeItem("bookingCustomerData");
    }
  };
  handleCustomerCancel = (data) => {
    localStorage.setItem("bookingCustomerCancelData", JSON.stringify(data));
    if (window.location.pathname === "/trips") {
      // window.location.reload();
      this.eventHandler(data, "booking-cancel-customer");
      localStorage.removeItem("bookingCustomerCancelData");
    } else {
      this.eventHandler(data, "booking-cancel-customer");
      localStorage.removeItem("bookingCustomerCancelData");
    }
  };
  handleDriverReg = (data) => {
    localStorage.setItem("driverRegData", JSON.stringify(data));
    if (window.location.pathname === "/trips") {
      // window.location.reload();
      this.eventHandler(data, "new-driver-registered");
      localStorage.removeItem("driverRegData");
    } else {
      this.eventHandler(data, "new-driver-registered");
      localStorage.removeItem("driverRegData");
    }
  };

  handleFareRequested = (data) => {
    console.log("fare-requested received:", data);
    localStorage.setItem("bookingEnquiryData", JSON.stringify(data));

    this.eventHandler(data, "fare-requested");

    localStorage.removeItem("bookingEnquiryData");
  };

  handleBookingConfirmedAgent = (data) => {
    localStorage.setItem("bookingConfirmedAgentData", JSON.stringify(data));

    this.eventHandler(data, "booking-confirmed-agent");

    localStorage.removeItem("bookingConfirmedAgentData");
  };

  handleBookingConfirmedCustomer = (data) => {
    localStorage.setItem("bookingConfirmedCustomerData", JSON.stringify(data));

    this.eventHandler(data, "booking-confirmed-customer");

    localStorage.removeItem("bookingConfirmedCustomerData");
  };

  // eventHandler = (data, eventType) => {
  //   this.setState({
  //     toastData: data,
  //     toastEventType: eventType,
  //   });
  // };
  eventHandler = (data, eventType) => {
    this.setState(
      {
        toastData: data,
        toastEventType: eventType,
      },
      () => {
        this.setState({
          toastData: null,
          toastEventType: null,
        });
      },
    );
  };

  render() {
    const {
      component: Component,
      isLoggedIn,
      auth,
      authorizedPages,
      sidebar: { visible: isOpen },

      notificationbar: { notificationvisible: Open },
      ...rest
    } = this.props;
    const { toastData, toastEventType } = this.state;

    return (
      <Route
        {...rest}
        render={(props) => {
          return (
            <div className="main-body">
              {isLoggedIn() ? (
                <React.Fragment>
                  <Header isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  <SideBar isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  <div
                    className={
                      isOpen && Open
                        ? "content"
                        : !isOpen
                          ? "content-open"
                          : "content-R open"
                    }
                  >
                    <BookingToaster
                      data={toastData}
                      eventType={toastEventType}
                      history={this.props.history}
                    />
                    {/* <BreadCrumb /> */}
                    <Component isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  </div>
                  <NotificationBar
                    isLoggedIn={isLoggedIn}
                    auth={auth}
                    {...props}
                  />
                </React.Fragment>
              ) : (
                <Component isLoggedIn={isLoggedIn} auth={auth} {...props} />
              )}
            </div>
          );
        }}
      />
    );
  }
}

export default withRouter(
  // Wrap Application component with withRouter
  connect((state) => {
    return {
      sidebar: state.sidebar,
      notificationbar: state.notificationbar,
      configCheck: state.configCheck,
    };
  })(Application),
);
